import { render, staticRenderFns } from "./SingleImage.vue?vue&type=template&id=2f4acafe&scoped=true&"
import script from "./SingleImage.vue?vue&type=script&lang=js&"
export * from "./SingleImage.vue?vue&type=script&lang=js&"
import style0 from "./SingleImage.vue?vue&type=style&index=0&id=2f4acafe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f4acafe",
  null
  
)

export default component.exports